module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ClientHeader"
  }, [_c('div', {
    staticClass: "ClientHeader-header"
  }, [(_vm.breadcrumbs) ? _c('icon', {
    staticClass: "ClientHeader-lockIcon",
    class: {
      'ClientHeader-lockIcon--isLarge': _vm.breadcrumbs[0].large
    },
    attrs: {
      "name": "lock",
      "width": _vm.breadcrumbs[0].large ? '18px' : '11px',
      "height": _vm.breadcrumbs[0].large ? '18px' : '11px'
    }
  }) : _vm._e(), _vm._v(" "), _c('breadcrumbs', {
    staticClass: "ClientHeader-breadcrumbs",
    attrs: {
      "items": _vm.breadcrumbs
    }
  })], 1), _vm._v(" "), (_vm.description) ? [_c('break', {
    attrs: {
      "size": "0.5"
    }
  }), _vm._v(" "), (_vm.description) ? _c('markdown', {
    staticClass: "c-grey-md-lt",
    attrs: {
      "content": _vm.description
    }
  }) : _vm._e()] : _vm._e(), _vm._v(" "), _c('break', {
    attrs: {
      "size": "2"
    }
  })], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-d3e65112"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ClientHeader.vue
// module id = 798
// module chunks = 1474